import { Reducer } from "redux";

import { TabSessionStorageDispatchTypes } from "../constants/TabSessionStorage";
import { TabSessionStorageResponse } from "../models/api/TabSessionStorage";
import { TabSessionDataDispatchTypes } from "../models/dispatchTypes/TabSessionStorage";

export const initialState: TabSessionStorageResponse = {
  loading: false,
  response: null as any,
  error: null,
};

const TabSessionReducer: Reducer<
  TabSessionStorageResponse,
  TabSessionDataDispatchTypes
> = (state = initialState, action: any) => {
  switch (action.type) {
    case TabSessionStorageDispatchTypes.SET_TAB_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case TabSessionStorageDispatchTypes.SET_TAB_DATA_SUCCESS:
      return { ...state, response: action.response, loading: false, error: {} };
    case TabSessionStorageDispatchTypes.SET_TAB_DATA_RESET:
      return initialState;
    default:
      return state;
  }
};

export default TabSessionReducer;
